import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"

import { useNetworkConditions } from "./useNetworkConditions"

export function useNetworkConditionForYearlyStatus(yearlyStatus) {
    const { selectedNetwork } = useNetworksStateContext()
    const queryParameters = useExtendWithSubnetworks({
        year: yearlyStatus?.year,
    }, API_MODULE_ROADWAY)
    const {
        isLoading,
        isError,
        data: networkConditions,
    } = useNetworkConditions(
        selectedNetwork?.slug,
        queryParameters,
    )

    const networkCondition = networkConditions?.[0]

    return { isLoading, isError, networkCondition }
}